import { Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsgService } from '../msg/msg.service';
import { UtilManipulateUI } from './utilManipulateUI';
import { UtilCalcTime } from './utilCalcTime';
import { UtilFile } from './utilFile';
import { UtilTransmission } from './utilTransmission';
import { UtilCalc } from './utilCalc';
import { UtilType } from './utilType';
import { UtilSmile9 } from './utilSmile9';

@Injectable()
export class UtilService {
  constructor(
    private http: HttpClient,
    private msgServ: MsgService,
    private title: Title,
  ) { }

  uUI = new UtilManipulateUI(this.title);
  uTime = new UtilCalcTime();
  uFile = new UtilFile();
  uTrans = new UtilTransmission(this.http);
  uType = new UtilType();
  uCalc = new UtilCalc();
  uSmile9 = new UtilSmile9();
}

